import { render, staticRenderFns } from "./contain_form.vue?vue&type=template&id=bfea1d8a&scoped=true"
import script from "./contain_form.vue?vue&type=script&lang=js"
export * from "./contain_form.vue?vue&type=script&lang=js"
import style0 from "./contain_form.vue?vue&type=style&index=0&id=bfea1d8a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfea1d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfea1d8a')) {
      api.createRecord('bfea1d8a', component.options)
    } else {
      api.reload('bfea1d8a', component.options)
    }
    module.hot.accept("./contain_form.vue?vue&type=template&id=bfea1d8a&scoped=true", function () {
      api.rerender('bfea1d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm_fine/views/parameter_center/activity_type/components/contain_form.vue"
export default component.exports